import { useProjectDeliverablesStore } from '@/stores/project/deliverables.store.js';
import { useProjectDetailsStore } from '@/stores/project/details.store.js';
import { useProjectDocumentsStore } from '@/stores/project/documents.store.js';
import { defineStore } from 'pinia';

export const useGridStore = defineStore('grid', {
  id: 'grid',
  state: () => ({
    gridApi: null, // AG Grid API reference,
    gridData: [], // data from the grid
    showNoRowsFilterOverlay: false,
  }),
  actions: {
    setGridApi(api) {
      this.gridApi = api;
    },
    setGridData(data) {
      this.gridData = data;
    },

    async updateFilterDropdownOptions(routeName) {
      const projectDetailsStore = useProjectDetailsStore();
      const projectDeliverablesStore = useProjectDeliverablesStore();
      const projectDocumentsStore = useProjectDocumentsStore(); // Assuming this is the correct store for documents

      // clear filter options
      projectDetailsStore.filterOptions = [];
      projectDeliverablesStore.filterOptions = [];
      projectDocumentsStore.filterOptions = [];

      if (!this.gridApi) return;

      const columnDefs = this.gridApi.getColumnDefs();

      // Apply column filter options to the current pinia store.
      for (const col of columnDefs) {
        const filterInstance = await this.gridApi.getColumnFilterInstance(col.field);

        if (routeName === 'Project-Creator-Details') {
          if (filterInstance?.filterNameKey !== 'numberFilter') {
            let options = filterInstance?.getValues ? filterInstance.getValues() : [];
            projectDetailsStore.setFilterOptions(col, options);
          } else {
            projectDetailsStore.setFilterOptions(col, []);
          }
        }

        if (routeName === 'Project-Deliverables') {
          if (filterInstance?.filterNameKey !== 'numberFilter') {
            let options = filterInstance?.getValues ? filterInstance.getValues() : [];
            projectDeliverablesStore.setFilterOptions(col, options);
          } else {
            projectDeliverablesStore.setFilterOptions(col, []);
          }
        }

        if (routeName === 'Project-Documents') {
          if (filterInstance?.filterNameKey !== 'numberFilter') {
            let options = filterInstance?.getValues ? filterInstance.getValues() : [];
            projectDocumentsStore.setFilterOptions(col, options);
          } else {
            projectDocumentsStore.setFilterOptions(col, []);
          }
        }
      }
    },
    clearFilters() {
      if (this.gridApi) {
        this.gridApi.setFilterModel(null); // Clear all filters
      }
    },
    refreshGrid() {
      if (this.gridApi) {
        this.gridApi.refreshCells(); // Refresh grid cells
      }
    },
    getFilteredData() {
      if (!this.gridApi) return [];
      const filteredData = [];
      this.gridApi.forEachNodeAfterFilterAndSort((node) => {
        filteredData.push(node.data);
      });
      return filteredData;
    },

    reDrawRows() {
      if (this.gridApi) {
        this.gridApi.redrawRows(); // Redraw all rows
      } else {
        console.error('Grid API not initialized.');
      }
    },
    /**
     * Update filters for specific columns.
     * @param {Object} filterModel - The new filter model for the grid.
     */
    updateFilters(filterModel) {
      if (this.gridApi) {
        this.gridApi.setFilterModel(filterModel); // Apply the new filters
      }
    },

    resetColumns() {
      if (this.gridApi) {
        this.gridApi.resetColumnState(); // Reset to the default column state
      } else {
        console.error('Column API not initialized.');
      }
    },
  },
});
